import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomerModel } from '../models/customer.model';
import { EventModel } from '../models/event.model';
import { OrderModel } from '../models/order.model';
import { TicketModel } from '../models/ticket.model';
import { MyOrdersRepository } from '../repositories/my-orders.repository';
import { PaymentRepository } from '../repositories/payment.repository';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private currentOrderSubject: BehaviorSubject<OrderModel>;

  constructor(private paymentRepository: PaymentRepository, private ordersRepository: MyOrdersRepository) {
    const currentOrder = JSON.parse(sessionStorage.getItem('currentOrder') ?? 'null');

    if (currentOrder) {
      this.currentOrderSubject = new BehaviorSubject<OrderModel>(currentOrder);
    } else {
      const customer = JSON.parse(sessionStorage.getItem('customerLogged') ?? 'null');
      const order: OrderModel = {
        event: null,
        customer: customer,
        tickets: [],
        termsOfUse: false
      }
      this.currentOrderSubject = new BehaviorSubject<OrderModel>(order);
      sessionStorage.setItem('currentOrder', JSON.stringify(order));
    }
  }

  public get currentOrder(): Observable<OrderModel> {
    return this.currentOrderSubject.asObservable();
  }

  public setEvent(event: EventModel): void {
    const order = this.currentOrderSubject.value;
    if (order.event && order.event.id != event.id) {
      order.tickets = [];
    }
    order.event = event;
    this.currentOrderSubject.next(order);
    sessionStorage.setItem('currentOrder', JSON.stringify(order));
  }

  public setCustomer(customer: CustomerModel): void {
    const order = this.currentOrderSubject.value;
    order.customer = customer;
    this.currentOrderSubject.next(order);
    sessionStorage.setItem('currentOrder', JSON.stringify(order));
  }

  public defineAdditionalCustomer(customer: CustomerModel): void {
    const order = this.currentOrderSubject.value;
    order.additionalCustomer = customer;
    this.currentOrderSubject.next(order);
    sessionStorage.setItem('currentOrder', JSON.stringify(order));
  }



  public setTermsOfUse(accept: boolean): void {
    const order = this.currentOrderSubject.value;
    order.termsOfUse = accept;
    this.currentOrderSubject.next(order);
    sessionStorage.setItem('currentOrder', JSON.stringify(order));
  }

  public termsOfUseAccepted() {
    return this.currentOrderSubject.value.termsOfUse;
  }

  /*
    adiciona um ingresso ao cachê
  */
  public addTicket(ticket: TicketModel, isSeatsIo?: boolean): void {
    if (isSeatsIo) {
      this.removeSeatsIoTicketsByPlaceName(ticket.placeName);
    }
    const order = this.currentOrderSubject.value;
    order.tickets.push(ticket);
    this.currentOrderSubject.next(order);
    sessionStorage.setItem('currentOrder', JSON.stringify(order));
  }

  /*
    remove todos os ingressos adicionados pelo seatsio
  */
  public removeSeatsIoTickets() {
    const order = this.currentOrderSubject.value;
    const index = order.tickets.map(t => t.isSeatsIo)
    order.tickets.forEach((ticket: any, index: number) => {
      if (ticket.isSeatsIo !== undefined) {
        if (ticket.isSeatsIo == true) {
          order.tickets.splice(index, 1);
          this.currentOrderSubject.next(order);
          sessionStorage.setItem('currentOrder', JSON.stringify(order));
        }
      };
    });
  }

  /*
    remove ingressos adicionados pelo seatsio pelo nome do lugar
  */
  public removeSeatsIoTicketsByPlaceName(placeName: string | undefined) {
    const order = this.currentOrderSubject.value;
    const index = order.tickets.map(t => t.placeName)
    order.tickets.forEach((ticket: any, index: number) => {
      if (ticket.placeName !== undefined) {
        if (ticket.placeName == placeName) {
          order.tickets.splice(index, 1);
          this.currentOrderSubject.next(order);
          sessionStorage.setItem('currentOrder', JSON.stringify(order));
        }
      };
    });
  }


  /*
     pega os ingressos salvos que foram adicionados caso o componente do seatsio tenha sido recarregado
  */
  public getAllTickets(): any {
    return JSON.parse(sessionStorage.getItem('currentOrder') ?? 'null').tickets;
  }

  /*
    remove ticket pelo id
  */
  public removeTicket(ticketId: string): void {
    const order = this.currentOrderSubject.value;
    const index = order.tickets.map(t => t.id).lastIndexOf(ticketId);
    if (index >= 0) {
      order.tickets.splice(index, 1);
      this.currentOrderSubject.next(order);
      sessionStorage.setItem('currentOrder', JSON.stringify(order));
    }
  }

  /*
    remove tickets do seatsio pelo assento
  */
  public removeTicketByPlaceName(placeName: string | undefined): void {
    // const order = this.currentOrderSubject.value;
    // const index = order.tickets.map(t => t.placeName).lastIndexOf(placeName);
    // if (index >= 0) {
    //   order.tickets.splice(index, 1);
    //   this.currentOrderSubject.next(order);
    //   sessionStorage.setItem('currentOrder', JSON.stringify(order));
    // }
    const order = this.currentOrderSubject.value;
    order.tickets.forEach((ticket: any, index: number) => {
      if (ticket.placeName == placeName) {
        order.tickets.splice(index, 1);
        this.currentOrderSubject.next(order);
        sessionStorage.setItem('currentOrder', JSON.stringify(order));
      }
    })
  }

  removeTicketByPlaceId(placeId: string) {
    const order = this.currentOrderSubject.value;

    for (let index = order.tickets.length - 1; index >= 0; index--) {
      const ticket = order.tickets[index];
      if (ticket.placeId == placeId) {
        order.tickets.splice(index, 1);
        this.currentOrderSubject.next(order);
        sessionStorage.setItem('currentOrder', JSON.stringify(order));
      }
    }
  }

  /*
    remove todos os tickets
  */
  public removeAllTickets(): void {
    const order = this.currentOrderSubject.value;
    order.tickets.length = 0
    this.currentOrderSubject.next(order);
    sessionStorage.removeItem('currentOrder');
  }

  /*
    deixa vazio todos os tickets
  */
  public emptyAllTickets(): void {
    const order = this.currentOrderSubject.value;
    order.tickets.length = 0
    this.currentOrderSubject.next(order);
  }


  public newMapReserve(data: any) {
    return this.ordersRepository.newMapReserve(data);
  }

  public getOrderEvent() {
    return JSON.parse(sessionStorage.getItem('currentOrder') ?? 'null').event;
  }

  /*
    conta os tickets que vem do componente tickets por quantidade
  */
  public countTickets(ticketId?: string, placeName?: string): number {
    if (ticketId) {
      return this.currentOrderSubject.value.tickets.filter(ticket => ticket.id == ticketId && ticket.placeName == placeName).length;
    }
    return this.currentOrderSubject.value.tickets.length;
  }

  // Verifica se o usuario logado tem cpf bloqueado no ingresso
  public existsBlacklist(): boolean {
    return this.currentOrderSubject.value.tickets.some(t => t.blacklist)
  }

  //Obtem o nome dos ticket na blacklist
  public ticketNameBlacklist(): string {
    return this.currentOrderSubject.value.tickets.map(t => (t.blacklist) ? t.name : '').filter(item => !!item).join('')
  }

  /*
    calcula o valor dos tickets que vem do componente tickets por quantidade
  */
  public amount(ticket?: any, withFees: boolean = true): number {
    let total = 0;
    if (ticket) {
      this.currentOrderSubject.value.tickets.forEach(t => {
        if (t.id == ticket.id && t.placeName == ticket.placeName) {
          if (withFees) {
            total += t.price + ticket.fee;
          } else {
            total += t.price;
          }
        }
      });
    } else {
      this.currentOrderSubject.value.tickets.forEach(t => {
        if (withFees) {
          total += t.price + t.fee;
        } else {
          total += t.price;
        }
      });
    }
    return total;
  }



  public fee(ticketId?: string): number {
    let fee = 0;
    if (ticketId) {
      this.currentOrderSubject.value.tickets.forEach(ticket => {
        if (ticket.id == ticketId) {
          fee += ticket.fee;
        }
      });
    } else {
      this.currentOrderSubject.value.tickets.forEach(ticket => {
        fee += ticket.fee
      });
    }
    return fee;
  }


  public sendPayment(params: any, queryString?: string): Observable<any> {
    return this.paymentRepository.sendPayment(params, queryString);
  }

  public getOrderById(id: string): Observable<any> {
    return this.ordersRepository.getOrderById(id);
  }

  /*
    adiciona um titular ao ingresso
  */
  public saveHolder(holder, id): void {
    const order = this.currentOrderSubject.value;
    order.tickets[id].customer = holder
    this.currentOrderSubject.next(order);
    sessionStorage.setItem('currentOrder', JSON.stringify(order));
  }

  // public isValidHolders(): boolean {
  //   const order = this.currentOrderSubject.value;
  //
  //   if (order.tickets.length == 0) {
  //     return false;
  //   }
  //
  //   const errors = order.tickets.filter(ticket => {
  //     return !ticket.holder
  //       || !ticket.holder.cpf
  //       || !ticket.holder.email
  //       || !ticket.holder.name
  //       || !ticket.holder.phone;
  //   });
  //
  //   return errors.length == 0;
  // }

  /*
    encontra pre order
  */
  getOrderByRfr(ids: any = [], forPaymentChange: boolean = false) {
    return this.ordersRepository.getOrderByRfr(ids, forPaymentChange);
  }


  public async changeOrderTicketTicketId(orderId: string, cpf: string) {
    return await this.ordersRepository.changeOrderTicketTicketId(orderId, cpf);
  }



}
